<template>
  <b-container class="cd-container cd-box-component">
    <b-row>
     <b-col cols="6"
        class="cd-entry cd-model p-2"
        v-bind:key="model.id"
        v-for="model in models"
        xs="6"
        sm="6"
        md="6"
        lg="3"
        xl="3"
        @click="selectModel(model)"
      >
        <Box
          v-bind:image="imageUriForModel(model)"
          class="cd-primary-sub-color"
        >
          <p class="cd-model-label">{{ model.label }}</p>
          <span class="cd-original-price">uvp ab {{ model.min_price_gross | formatCurrency }}&nbsp;€</span>
          <span class="cd-new-price">ab {{ getNewPrice(model['min_price_'+pricing], model) | formatCurrency }}&nbsp;€</span>
          <div class="cd-new-price" v-if="shouldDisplayRate(model) && getRate(model) != null">{{ getRate(model) | formatCurrency }} € / Monat</div>
          <button type="button" class="btn btn-primary btn-hover">jetzt konfigurieren</button>
        </Box>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Box from "../elements/Box";
import { mapGetters, mapActions } from "vuex";
import config from "../../config";
import api from '../../services/ApiService';
import store from '../../data/store';
import ConditionsService from '../../services/ConditionsService';
import TrackingService from "../../services/TrackingService";
import ImageService from "../../services/ImageService";

export default {
  created() {
    this.$store.commit("setProgress", {
      progress: 2,
      title: "Modell",
      subline: "Wählen Sie ein Modell aus.",
    });
    this.$store.commit("setShowCarInfo", false);    
  },
    
  beforeRouteEnter(to, from, next) {
    store.commit("setShowCarInfo", false);
    store.commit("setShowEquipmentCompairsionLink", false);
    next();
  },
  /* eslint-disable no-debugger */
  mounted() { 
    ConditionsService.initialize(this.conditions);
    const route = this.$router.currentRoute;
    const vm = this;
    
    window.addEventListener("cds-rates-updated", this.handleRateUpdates);

    if(!this.$props.makerId) {
      return api.getMaker(route.params.maker).then(maker => {
        vm.$store.commit("carConfiguration/setCurrentMaker", maker);
        this.fetchModels(maker.id);
      });     
    }else {
      this.fetchModels(this.$props.makerId);
    }
  },
  beforeDestroy() {
    window.removeEventListener("cds-rates-updated", this.handleRateUpdates);
  },
  methods: {
    ...mapActions({
      fetchModels: "models/fetchModels",
    }),
    imageUriForModel(model) {
      return ImageService.buildImaginImageUrl(this.maker, model);
      /*
      let dbName = "SSCD" in model.photo_path ? "SSCD" : "NSCD";

      let segments = model.photo_path[dbName].split('/');

  
      segments[0] = this.maker.label.toUpperCase();
      segments[1] = model.label.toUpperCase();

      let finalPath = segments.join('/');

      return (
        config.apiUri +
        "/ngphotos/" +
        dbName +
        "/" +
        finalPath +
        "/" +
        model.photo_filename[dbName] +
        ".JPG"
      );*/
    },
    getRate(model) {
      console.log("MODEL!")
      console.log(model)
      if(!Object.hasOwn(model.min_engine,"SSCD")) 
      {        
        return null
      }

      if(this.rates.has(model.min_engine.SSCD.engine)) {
        
        return this.rates.get(model.min_engine.SSCD.engine);
      }

      return null;
    },
    shouldDisplayRate(model) {
      if(Object.hasOwn(model.min_engine, "SSCD")) {        
        return true
      }

      return false;
    },
    selectModel(model) {
      const maker = this.$route.params.maker;
      TrackingService.trackStage("Step 2 - Konfiguration", `${maker} - ${model.label}`);
  

      this.$store.commit("carConfiguration/setCurrentModel", model);  
      this.$router.push({
        name: "body_designs",
        params: { maker: maker, model: model.label, modelId: model.id },
      });
    },
    getNewPrice(oldPrice, data) {
      if(!this.conditions.size) {
        return oldPrice;
      }
      return ConditionsService.getNewPrice(oldPrice, data);
    },
    handleRateUpdates(ev) {
      this.rates = ev.detail.rates;
    }
  },
  watch: {
    conditions(val) {
      ConditionsService.initialize(val);
    },
    models(val) {
      
      let res = [];
      val.forEach(x => {
        if(x.min_engine.SSCD != undefined) {
          res.push({
            maker: this.maker.label,
            model: x.label, 
            engine_id: x.min_engine.SSCD.engine,
            min_price_gross: x.min_price_gross,
            min_price_net: x.min_price_net
          });
        }
      })

      TrackingService.trackAdvanced(2, res);      
    }
  },
  computed: {
    ...mapGetters({
      models: "models/models",
      maker: "carConfiguration/currentMaker",
      conditions: "conditions/conditions"
    }),
    pricing() {
      return config.pricing;
    },
    computedMakerId() {
      return this.$props.makerId || this.fetchedMakerId;
    },
  },
  components: {
    Box,
  },
  data: function () {
    return {
      fetchedMakerId: "",
      rates: new Map()
    };
  },
  props: ["makerId"],
};
</script>

<style>

</style>
